import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { updateAppAccessControlSwitchAction } from 'Actions/appAccessControlAction';
import { ModuleActions } from 'Constants/Modules.constants';
import { toast as toastr } from 'react-toastify';
import Popup from 'Components/Common/PopUp';

const Switch = (props) => {
    const [ enabled, setEnabled ] = useState(props.appAccessControlSwitch.isEnabled);
    const [ enableCofirmPopup, setEnableCofirmPopup ] = useState(false);

    useEffect(() => {
        setEnabled(props.appAccessControlSwitch.isEnabled);
     }, [ props.appAccessControlSwitch.isEnabled ]);

    const handleSwitch = (e) => {
        if(!props.permission?.[ ModuleActions.accessControl ]) {
            toastr.dismiss();
            toastr.error('You don\'t have the permission to perform this action');
            return;
        }

        if(e.target.checked){
            setEnableCofirmPopup(true);
            return;
        }
        props.updateAppAccessControlSwitchAction(e.target.checked)
    }

    const toggleEnableConfirmPopup = () => {
        setEnableCofirmPopup(!enableCofirmPopup);
    }

    const handleConfirm = () => {
        toggleEnableConfirmPopup();
        props.updateAppAccessControlSwitchAction(true)
    }

    return (
        <>
            <div class="switch-btn">
                <input type="checkbox" id="switch" onChange={ handleSwitch } checked={ enabled } />
                <label for="switch">Toggle</label>
            </div>
            { enableCofirmPopup &&
                <Popup textStyle={ { lineHeight: '1.8em' } } popupText={ `Enabling this will force log-out all the users.<br />Do you want to continue?` } yesText='Confirm' handleYes={ handleConfirm } handleCancel={ toggleEnableConfirmPopup } />
            }
        </>
    )
}

export default connect((state) => {
    return {
        appAccessControlSwitch: state.appAccessControlSwitch
    }
}, { updateAppAccessControlSwitchAction })(Switch);